import Enterprise24 from '@carbon/icons-react/es/enterprise/24';
import Task16 from '@carbon/icons-react/es/task/16';
import moment from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { InfoStatus, TimesheetApproved } from 'api/notifications/meta';
import { Avatar } from 'components/atoms/avatar';
import {
  NameCellWithTooltip,
  StatusIndicatorWrapper,
} from 'components/organisms/timesheets/common/cells/name-cell';
import { Causer } from '../causer';
import { WeekViewLink } from './week-view';

const NameCellWithTooltipStyled = styled(NameCellWithTooltip)`
  height: fit-content;
  padding: 0;
`;

export const ProjectName = (project) => {
  const { projectId, customer, projectName } = project;

  return (
    <NameCellWithTooltipStyled
      logo={
        projectId ? (
          <StatusIndicatorWrapper>
            <Avatar
              src={customer.companyLogoUrl}
              name={projectName}
              icon={<Task16 />}
              size="small"
            />
          </StatusIndicatorWrapper>
        ) : (
          <Enterprise24 />
        )
      }
      primaryText={
        projectName || (
          <FormattedMessage id="timesheets.labels.non_project_activity" />
        )
      }
    />
  );
};

export const TimesheetApprovedView: FC<{
  meta: TimesheetApproved;
  userId: number;
}> = ({ userId, meta }) => {
  const { by, info, start } = meta;

  if (info?.status) {
    switch (info.status) {
      case InfoStatus.Approved:
        if (info?.project?.projectId) {
          return (
            <FormattedMessage
              id="notifications.messages.timesheet_approved.project"
              values={{
                causer: <Causer user={by} />,
                week: <WeekViewLink start={moment(start)} userId={userId} />,
                project: ProjectName(info.project),
              }}
            />
          );
        }

        return (
          <FormattedMessage
            id="notifications.messages.timesheet_approved"
            values={{
              causer: <Causer user={by} />,
              week: <WeekViewLink start={moment(start)} userId={userId} />,
            }}
          />
        );
      case InfoStatus.PartiallyApproved:
        return (
          <FormattedMessage
            id="notifications.messages.timesheet_partially_approved.project"
            values={{
              causer: <Causer user={by} />,
              week: <WeekViewLink start={moment(start)} userId={userId} />,
              project: ProjectName(info.project),
            }}
          />
        );
      case InfoStatus.Rejected:
        if (info?.project?.projectId) {
          if (info.notes && info.notes?.length > 1) {
            return (
              <FormattedMessage
                id="notifications.messages.timesheet_rejected.comments.project"
                values={{
                  causer: <Causer user={by} />,
                  week: <WeekViewLink start={moment(start)} userId={userId} />,
                  number: info.notes?.length,
                  project: ProjectName(info.project),
                }}
              />
            );
          }

          return (
            <FormattedMessage
              id="notifications.messages.timesheet_rejected.project"
              values={{
                causer: <Causer user={by} />,
                week: <WeekViewLink start={moment(start)} userId={userId} />,
                project: ProjectName(info.project),
              }}
            />
          );
        }

        return (
          <FormattedMessage
            id="notifications.messages.timesheet_rejected"
            values={{
              causer: <Causer user={by} />,
              week: <WeekViewLink start={moment(start)} userId={userId} />,
            }}
          />
        );
        break;
      default:
        return <></>;
    }
  }

  return (
    <FormattedMessage
      id="notifications.messages.timesheet_approved"
      values={{
        causer: <Causer user={by} />,
        week: <WeekViewLink start={moment(start)} userId={userId} />,
      }}
    />
  );
};
